var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-qrcode"},[_c('img',{staticClass:"xt-qrcode-img",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }